import {
    type EntitySuggestionItem,
    type EntityTypeMeta,
    type EntityTypeId,
} from '@components/AnalystChat/ChatInput/types';

export interface PaginationState {
    currentPage: number;
    perPage: number;
    totalItems: number;
    hasMore: boolean;
}

export interface EntityDataState<T> {
    data: T[];
    pagination: PaginationState;
    isLoading: boolean;
    error: Error | null;
}

export interface EntityMentionState {
    selectedEntityType: EntityTypeId | null;

    entities: Record<EntityTypeId, EntityDataState<EntitySuggestionItem>>;

    genericSearchResults: EntitySuggestionItem[];
    genericSearchLoading: boolean;

    entityMeta: EntityTypeMeta;
    availableEntityTypes: EntityTypeId[];

    // UI state
    mentionSuggestionOpen: boolean;
    searchQuery: string;
}

export interface EntityMentionContext {
    state: EntityMentionState;
    actions: {
        setSelectedEntityType: (entityType: EntityTypeId | null) => void;
        setSearchQuery: (query: string) => void;
        setMentionSuggestionOpen: (open: boolean) => void;
        fetchEntities: (
            entityType: EntityTypeId,
            page?: number,
        ) => Promise<void>;
        loadMoreEntities: (entityType: EntityTypeId) => Promise<void>;
    };
}

export enum ActionType {
    SET_SELECTED_ENTITY_TYPE,
    SET_ENTITIES,
    SET_ENTITY_LOADING,
    SET_ENTITY_ERROR,
    SET_SEARCH_QUERY,
    SET_GENERIC_SEARCH_RESULTS,
    RESET_ENTITY_DATA,
    SET_MENTION_SUGGESTION_OPEN,
    SET_ENTITY_META,
}
